<template>
  <div class="container-fluid py-4">

    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-pencil-square fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Modification d'un Service</h2>
      </div>
      <router-link class="btn btn-primary btn-lg shadow-sm btn-clinique" :to="{ name: 'liste_service' }">
        <i class="bi bi-arrow-left-circle me-2"></i> Retour
      </router-link>
    </div>

    <!-- Card formulaire -->
    <div class="card p-4 shadow-sm rounded card-clinique" v-if="!isLoading">
      <div class="row g-4">
        <!-- Nom du service -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Nom du service</label>
          <input type="text" v-model="service.nom"
                 class="form-control form-control-clinique"
                 :class="{ 'is-invalid': errors.nom }"
                 placeholder="Ex : Consultation">
          <div class="invalid-feedback">{{ errors.nom }}</div>
        </div>

        <!-- Type de service -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Type de service</label>
          <select v-model="service.typeId"
                  class="form-select form-select-clinique"
                  :class="{ 'is-invalid': errors.typeId }">
            <option value="">-- Sélectionner un type --</option>
            <option v-for="ts in typeServices" :key="ts.id" :value="ts.id">
              {{ ts.nom }}
            </option>
          </select>
          <div class="invalid-feedback">{{ errors.typeId }}</div>
        </div>

        <!-- Prix -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Prix (FCFA)</label>
          <input type="number" v-model="service.prix"
                 class="form-control form-control-clinique"
                 min="0"
                 placeholder="Ex : 5000">
        </div>
      </div>

      <!-- Payé -->
      <div class="row g-4 mt-1">
        <div class="col-md-6 d-flex align-items-center">
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" v-model="service.isEnabled">
            <label class="form-check-label ms-2 fw-semibold">
              Activé?
            </label>
          </div>
        </div>
      </div>

      <!-- Boutons -->
      <div class="d-flex justify-content-end gap-3 mt-4">
        <button class="btn btn-light border shadow-sm px-4 py-2" @click="cancel">
          <i class="bi bi-x-circle me-1"></i> Annuler
        </button>
        <button class="btn btn-success shadow px-4 py-2 btn-clinique" :disabled="isSaving" @click="updateService">
          <i class="bi bi-save me-1"></i> Mettre à jour
        </button>
      </div>
    </div>

    <!-- Spinner -->
    <div v-else class="text-center my-5">
      <div class="spinner-border text-primary" style="width: 4rem; height: 4rem;"></div>
      <p class="mt-2">Chargement du service...</p>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {
      isLoading: true,
      isSaving: false,
      typeServices: [],
      service: {
        nom: '',
        typeId: '',
        prix: 0,
        isEnabled: false
      },
      errors: {
        nom: '',
        typeId: ''
      }
    };
  },
  methods: {
    async fetchTypeServices() {
      try {
        const res = await api.getItems('type_services', { itemsperpage: 100 });
        this.typeServices = res.data.data || res.data;
      } catch (error) {
        console.error('Erreur fetch type_services', error);
      }
    },
    async fetchService() {
      try {
        const id = this.$route.params.id;
        const res = await api.getItem('services', id);
        const s = res.data;

        // Vérifier si typeServices est déjà chargé
        if (!this.typeServices.length) {
          await this.fetchTypeServices();
        }

        // Trouver le type correspondant pour le select
        const typeMatch = this.typeServices.find(t => t.id === s.type?.id);

        this.service = {
          nom: s.nom,
          typeId: typeMatch ? typeMatch.id : '',  // correspondance exacte
          prix: s.prix || 0,
          isEnabled: Boolean(s.isEnabled)
        };
      } catch (error) {
        console.error('Erreur fetch service', error);
        alert("Impossible de charger le service.");
      } finally {
        this.isLoading = false;
      }
    },
    validateForm() {
      this.errors.nom = this.service.nom ? '' : 'Le nom est requis';
      this.errors.typeId = this.service.typeId ? '' : 'Le type est requis';
      return !Object.values(this.errors).some(e => e !== '');
    },
    async updateService() {
      if (!this.validateForm()) return;

      try {
        this.isSaving = true;
        const payload = {
          nom: this.service.nom,
          type: this.service.typeId,
          prix: this.service.prix,
         // estPaye: this.service.estPaye,
          isEnabled: this.service.isEnabled
        };
        const id = this.$route.params.id;
        await api.updateItem('services', id, payload);
        alert('Service mis à jour avec succès !');
        this.$router.push({ name: 'liste_service' });
      } catch (error) {
        console.error('Erreur update service', error);
        alert("Erreur lors de la mise à jour.");
      } finally {
        this.isSaving = false;
      }
    },
    cancel() {
      this.$router.push({ name: 'liste_service' });
    }
  },
  async created() {
    // Charger les types avant le service pour que le select fonctionne
    await this.fetchTypeServices();
    await this.fetchService();
  }
};
</script>

<style scoped>
.header-clinique {
  padding: 15px 20px;
  background-color: #e9f5ff;
  border-radius: 12px;
  margin-bottom: 20px;
}
.card-clinique {
  background: #f8fafd;
  border-radius: 12px;
  border: none;
}
.form-control-clinique,
.form-select-clinique {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
  padding: 10px 14px;
  transition: all 0.3s ease;
}
.form-control-clinique:focus,
.form-select-clinique:focus {
  box-shadow: 0 0 6px #0d6efd33;
  border-color: #0d6efd;
}
.btn-clinique {
  background: linear-gradient(90deg, #0d6efd, #6610f2);
  border: none;
  color: #fff;
  border-radius: 10px;
  transition: all 0.3s ease;
}
.btn-clinique:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  transform: translateY(-2px);
}
</style>
